import { Alert, Heading } from '@mm/components';
import moment from 'moment';
import React, { useState } from 'react';
import {
  ButtonColor,
  PrimaryButton,
} from '../../buttons/PrimaryButton/PrimaryButton';
import {
  CloseModalProps,
  ModalBody,
  ModalFooter,
  ModalHeader,
} from '../modal-helpers';
import './SubscriptionPausingModal.pcss';

type Props = CloseModalProps;

// Note: the component will be finished as a part of a separate ticket
export const SubscriptionPausingModal = (props: Props) => {
  const { closeModal } = props;

  const [isPaused, setIsPaused] = useState(false);

  const onClose = (ok: boolean) => {
    if (ok) {
      setIsPaused(true);
      return;
    }

    closeModal();
    // TODO: implement
  };

  return (
    <div className="subscription_pausing_modal">
      <ModalHeader className="subscription_pausing_modal__header">
        <Heading size={3} text="Pause my subscription" />
      </ModalHeader>
      <ModalBody className="subscription_pausing_modal__body">
        {isPaused ? (
          <Alert type="success" showCloseIcon={false} showInfoIcon>
            Subscription is paused for 1 month
          </Alert>
        ) : (
          <>
            <div>Dropdown Placeholder</div>
            <div>
              Your subscription will be reactivated on{' '}
              {moment().add(1, 'months').format('MM/DD/YYYY')}
            </div>
          </>
        )}
      </ModalBody>

      <ModalFooter className="subscription_pausing_modal__footer">
        {!isPaused && (
          <>
            <PrimaryButton
              className="subscription_pausing_modal__button--cancel"
              color={ButtonColor.gray}
              onClick={() => onClose(false)}
            >
              Cancel
            </PrimaryButton>
            <PrimaryButton
              color={ButtonColor.blue}
              className="subscription_pausing_modal__button"
              onClick={() => onClose(true)}
            >
              Confirm
            </PrimaryButton>
          </>
        )}
      </ModalFooter>
    </div>
  );
};
